<template>
    <div class="d-flex justify-center">
        <v-card
            :width="mobile ? '90%' : '75%'"
            max-height="78vh"
            color="white"
            elevation="3"
            class="d-flex flex-column"
        >
            <v-data-table-server
                :headers="customer.headers"
                :items="customer.lstCustomer"
                :items-per-page="customer.itemsPerPage"
                no-data-text="Nenhum cliente encontrado"
                @click:row="openCustomer"
                class="card-scroll"
                :page="customer.page"
                :items-length="customer.totalItems"
                @update:options="updateOptions"
            >
                <template v-slot:top>
                    <div :class="['px-5', mobile ? 'pb-3' : '']">
                        <v-row align="center" dense>
                            <v-col cols="12" md="9">
                                <v-text-field
                                    v-model="customer.search"
                                    label="Pesquise aqui"
                                    variant="outlined"
                                    color="primary"
                                    density="compact"
                                    max-width="300px"
                                    rounded
                                    class="pt-6"
                                    @keyup.enter="search()"
                                >
                                    <template v-slot:append-inner>
                                        <v-btn
                                            icon
                                            size="small"
                                            variant="text"
                                            @click="search()"
                                        >
                                            <v-icon class="pt-1">mdi-magnify</v-icon>
                                        </v-btn>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="3" class="d-flex justify-end">
                                <v-btn
                                    color="primary"
                                    @click="openNewCustomer()"
                                    rounded
                                    variant="elevated"
                                >
                                    Adicionar
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                    <v-divider></v-divider>
                </template>
                <template #headers="{ columns }">
                    <tr class="custom-header" >
                        <th v-for="column in columns" :key="column.key" style="text-align: center; font-weight: 600;">
                            {{ column.title }}
                        </th>
                    </tr>
                </template>
            </v-data-table-server>
        </v-card>
    </div>
    <Customer/>
</template>

<script>
import { useDisplay } from 'vuetify'
import Customer from '../Customer.vue';

export default {
    setup () {
        const { mobile } = useDisplay()
        return { mobile }
    },
    data: () => ({
    }),
    components: {
        Customer
    },
    computed: {
        customer: {
            get() {
                return this.$store.state.customer
            },
        },
    },
    methods: {
        async openCustomer(event, row) {
            this.$router.push({
                name: 'EditCustomer',
                params: {
                    customerId: row.item.customerId
                }
            })
        },
        openNewCustomer() {
            this.$router.push({ name: 'NewCustomer' })
        },
        async search() {
            await this.$store.dispatch("customer/search", { limit: this.customer.itemsPerPage, reset: true })
        },
        async updateOptions(options) {
            this.$store.commit('customer/setPage', options.page)

            await this.$store.dispatch("customer/search", {
                limit: options.itemsPerPage,
                page: options.page,
                reset: true
            })
        }
    },
    async mounted() {
        await this.search()
    },
    watch: {
        '$store.state.customer.shouldReload': {
            async handler(val) {
                if (val) {
                    await this.search()
                    this.$store.commit('customer/setShouldReload', false)
                }
            }
        }
    }
}
</script>

<style>
.card-scroll {
  overflow-y: auto;
  scrollbar-width: thin;
}
</style>